import React from 'react';
import styled from 'styled-components';
import Address from './Address';

const FooterItem = styled.div`
  width: 100%;
  display: inline-block;
  margin: 0 4px 2rem;
  border-bottom: 1px solid #111;

  @media (min-width: 768px) {
    width: 45%;
  }

  @media (min-width: 1024px) {
    width: 20%;
    border: none;
  }
`;

const FooterItemHeading = styled.h4`
  color: white;
  font-size: 1.2rem;
`;

const FooterItemLink = styled.a`
  text-decoration-color: white;
  color: white;
  font-size: 0.8rem;
`;

const Container = styled.footer`
  padding: 32px;
  background-color: #444;
  color: white;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const ItemAddress = ({ address }) => {
  return (
    <FooterItem>
     <FooterItemLink
      target="_blank"
      href="http://maps.google.co.uk/maps?q=51.501604,-2.587001&hl=en&ll=51.501243,-2.587194&spn=0.004228,0.008068&sll=51.50173,-2.587366&sspn=0.004228,0.008068&t=m&z=17"
      rel="noopener noreferrer">
        <FooterItemHeading>Address</FooterItemHeading>
      </FooterItemLink>
      <Address address={address} />
    </FooterItem>
  );
};

const ItemTelephone = ({ telephoneNumber }) => {
  return (
    <FooterItem>
      <FooterItemHeading>Telephone</FooterItemHeading>
      <address>
        <FooterItemLink href={`tel:${telephoneNumber.replace(/\s/g, '')}`}>{telephoneNumber}</FooterItemLink>
      </address>
    </FooterItem>
  );
};

const ItemEmail = ({ emailAddress }) => {
  return (
    <FooterItem>
      <FooterItemHeading>Email</FooterItemHeading>
      <address>
        <FooterItemLink
          href={`mailto:${emailAddress}`}
          title="Email Ian Willmott">{emailAddress}</FooterItemLink>
      </address>
    </FooterItem>
  );
};

const ItemSocialMedia = ({ socialMedia }) => {
  const { facebook, twitter } = socialMedia;
  return (
    <FooterItem>
      <FooterItemHeading>Social Media</FooterItemHeading>
      <div>
        <FooterItemLink
          href="https://twitter.com/backsgetbetter?ref_src=twsrc%5Etfw"
          target="_blank"
          rel="noopener noreferrer">Twitter</FooterItemLink>
      </div>
      <div>
        <FooterItemLink
          target="_blank"
          rel="noopener noreferrer"
          href={facebook}>Facebook</FooterItemLink>
      </div>
    </FooterItem>
  );
}

const Footer = ({ contactDetails }) => {
  const { address, telephoneNumber, emailAddress, socialMedia } = contactDetails;
  return (
    <Container>
      <ItemAddress address={address} />
      <ItemTelephone telephoneNumber={telephoneNumber} />
      <ItemEmail emailAddress={emailAddress} />
      <ItemSocialMedia socialMedia={socialMedia} />
    </Container>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js